import styled from '@emotion/styled';

interface ToggleIconProps {
  isCollapsed: boolean;
}

const IconWrapper = styled.button<ToggleIconProps>`
  width: 21px;
  height: 21px;
  background: #fff;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s;

  &:hover {
    background: #fff;
  }

  svg {
    transform: ${(props) => (props.isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)')};
    transition: transform 0.2s;
  }
`;

export const ToggleIcon = ({ isCollapsed }: ToggleIconProps) => {
  return (
    <IconWrapper isCollapsed={isCollapsed} aria-label={isCollapsed ? 'Expand' : 'Collapse'}>
      {!isCollapsed && (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 20" fill="none">
          <path d="M4.16602 10H15.8327" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      )}
      {isCollapsed && (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M4.16699 10H15.8337" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
          <path d="M10 4.16663V15.8333" stroke="#2E2E2E" strokeLinecap="round" strokeLinejoin="round"></path>
        </svg>
      )}
    </IconWrapper>
  );
};

export default ToggleIcon;
